/** Return OAuth results to the native app only when Android started this flow. */
export function bridgeNativeOAuth(state, provider, code, error, errorDescription) {
  const marker = 'b2sandroid_';
  if (!state?.startsWith(`${marker}${provider}:`)) return false;

  const callback = new URL('brand2social://oauth');
  callback.searchParams.set('provider', provider);
  if (code) callback.searchParams.set('code', code);
  if (error) callback.searchParams.set('error', error);
  if (errorDescription) callback.searchParams.set('error_description', errorDescription);
  callback.searchParams.set('state', state);
  window.location.assign(callback.toString());
  return true;
}

export function bridgeNativeOAuthFromState(state, code, error, errorDescription, allowedProviders) {
  const marker = 'b2sandroid_';
  if (!state?.startsWith(marker)) return false;
  const provider = state.slice(marker.length).split(':', 1)[0];
  if (!allowedProviders.includes(provider)) return false;
  return bridgeNativeOAuth(state, provider, code, error, errorDescription);
}
